<footer class="border-top">
    <div class="container">
        <div class="wrapper">
            <div class="row">
                <div class="col-lg-3 col-md-5 logo-wrap pt-3">
                    <a href="/"><img src="assets/images/logo.png" height="32"></a>
                    <p class="my-2 pl-1 text-gray"><small>© Apeiron 2020. All Rights Reserved</small></p>
                    <div class="social-media py-2 d-flex align-items-center">
                        <a href="https://www.facebook.com/ApeironCenter/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#fff"
                                viewBox="0 0 24 24">
                                <path
                                    d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" />
                            </svg>
                        </a>

                        <a href="https://twitter.com/ApeironMe">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 -1.5 20 20">
                                <path fill="#fff"
                                    d="M6.286 16.5c7.551 0 11.682-6.539 11.682-12.206a9 9 0 0 0-.022-.555A8.677 8.677 0 0 0 20 1.506a7.61 7.61 0 0 1-2.354.68 4.32 4.32 0 0 0 1.799-2.369c-.805.5-1.688.853-2.61 1.042a3.986 3.986 0 0 0-2.987-1.36C11.553-.47 9.715 1.452 9.74 3.794c.003.329.04.656.11.976C6.529 4.581 3.448 2.947 1.388.282a4.536 4.536 0 0 0-.555 2.165 4.358 4.358 0 0 0 1.832 3.57 3.915 3.915 0 0 1-1.866-.544v.057C.784 7.554 2.16 9.313 4.097 9.746a4.214 4.214 0 0 1-1.088.147 4.19 4.19 0 0 1-.766-.079c.516 1.731 2.059 2.932 3.831 2.98A7.976 7.976 0 0 1 .977 14.63 9.129 9.129 0 0 1 0 14.573 11.277 11.277 0 0 0 6.286 16.5" />
                            </svg>
                        </a>

                        <a href="https://www.linkedin.com/company/apeiron-center-for-human-potential/">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 20 20">
                                <path
                                    d="M17.041 17.042h-2.964V12.4c0-1.107-.021-2.53-1.541-2.53-1.544 0-1.78 1.205-1.78 2.45v4.72H7.794V7.499h2.843v1.304h.041c.396-.75 1.364-1.542 2.807-1.542 3.001 0 3.556 1.976 3.556 4.547v5.235zM4.45 6.193a1.72 1.72 0 1 1-.003-3.439 1.72 1.72 0 0 1 .003 3.44zM2.964 17.042h2.969V7.498h-2.97v9.544zM18.518 0H1.475C.662 0 0 .646 0 1.441v17.116c0 .796.662 1.442 1.475 1.442h17.043c.815 0 1.482-.646 1.482-1.442V1.44C20 .646 19.333 0 18.518 0z"
                                    fill="#fff" fill-rule="evenodd" /></svg>
                        </a>

                        <a href="https://www.youtube.com/channel/UC1D2PHjaxouPD3KdBVAzJiQ">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#fff"
                                viewBox="0 0 24 24">
                                <path
                                    d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z" />
                            </svg>
                        </a>

                        <a href="https://www.instagram.com/apeironme/">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                width="12" height="12" viewBox="0 0 170 170" xml:space="preserve">
                                <g>
                                    <path fill="#fff"
                                        d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752 c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407 c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752 c17.455,0,31.656,14.201,31.656,31.655V122.407z" />
                                    <path fill="#fff"
                                        d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561 C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561 c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z" />
                                    <path fill="#fff"
                                        d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78 c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78 C135.661,29.421,132.821,28.251,129.921,28.251z" />
                                </g>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="col-lg-9 col-md-7 footer-menus pt-3">
                    <div class="row">
                        <div class="col-lg-4 footer-menu">
                            <p><a href="#" class="mb-1 text-decoration">Contact Us</a>
                            </p>
                            <p>
                                <a href="tel:+15124000115" class="mb-1 text-decoration">(512) 400-0115</a>
                            </p>
                            <p>
                                <a href="mailto:info@apeironcenter.com"
                                    class="mb-1 text-decoration">info@apeironcenter.com</a>
                            </p>
                        </div>
                        <div class="col-lg-4 footer-menu">
                            <p>
                                <a href="privacy-policy" class="text-decoration mb-1">Privacy Policy</a>
                            </p>
                        </div>
                        <div class="col-lg-4 footer-menu">
                            <p>
                                <a href="cookie-policy" class="text-decoration mb-1">Cookie Policy</a>
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</footer>